import { Pipe, PipeTransform } from '@angular/core';

import { isProductActive } from 'src/app/constants/constants';

@Pipe({ name: 'erpPermission' })
export class ErpPermissionPipe implements PipeTransform {
  transform(
    isMaster: boolean,
    customerAlias: any,
    customerDocument: any,
    hasUserWebAccess: boolean,
    userMetaData: any
  ) {
    if (
      isProductActive(
        isMaster,
        customerAlias,
        customerDocument,
        hasUserWebAccess,
        userMetaData,
        'eppProducts'
      )
    ) {
      const product = customerDocument['eppProducts'][0];
      if (product.hasOwnProperty('regions') && product['regions'].length > 0) {
        return true;
      }
    }
    return false;
  }
}
